<template>
  <div>
    <b-card>
      <ValidationObserver ref="trainer" v-slot="{ handleSubmit }">
        <b-form class="form-top p-4" @submit.prevent="handleSubmit(formSubmit)">
          <b-row>
            <b-col md="6">
              <input-form
                v-model="trainer.trainer.translations[0].name"
                :name="$t('trainers.nameAr')"
                :label="$t('trainers.nameAr')"
                validate="required"
                :disabled="disableStatus"
              />
            </b-col>
            <b-col md="6">
              <input-form
                v-model="trainer.trainer.translations[1].name"
                :name="$t('trainers.nameEn')"
                :label="$t('trainers.nameEn')"
                validate="required"
                :disabled="disableStatus"
              />
            </b-col>
          </b-row>

          <form-btns
            v-if="currentPage != itemPages.view"
            :label="submitLabel"
            :loading="loading"
          />
        </b-form>
      </ValidationObserver>
    </b-card>

    <b-card v-if="currentPage == itemPages.view">
      <horses :trainerId="id" :titleStatus="true" />
    </b-card>
  </div>
</template>
<script>
import { core } from "../../../../config/pluginInit";
import trainerServices from "../services/trainers";
import Trainer from "../models/Trainer";
import Horses from "../../horses/views/Horses.vue";
import moduleItemMixin from "../../../../Mixins/moduleItemMixin";

export default {
  mixins: [moduleItemMixin],
  components: { Horses },
  data() {
    return {
      trainer: new Trainer(),
    };
  },
  methods: {
    async create() {
      trainerServices
        .create({ translations: this.trainer.trainer.translations })
        .then((response) => {
          this.loading = false;
          core.showSnackbar("success", response.data.message);
          this.lastRoute.name
            ? this.$router.push(this.lastRoute)
            : this.$router.push({ name: "contributor.trainers" });
        })
        .catch(() => {
          this.loading = false;
        });
    },
    async update() {
      trainerServices
        .update(this.id, {
          translations: this.trainer.trainer.translations,
        })
        .then((response) => {
          this.loading = false;
          core.showSnackbar("success", response.data.message);
          this.lastRoute.name
            ? this.$router.push(this.lastRoute)
            : this.$router.push({ name: "contributor.trainers" });
        })
        .catch(() => {
          this.loading = false;
        });
    },
  },
  mounted() {
    core.index();
  },
  created() {
    if (this.id) {
      trainerServices.findOne(this.id).then((response) => {
        this.trainer.fillData(response.data.data);
        this.loading = false;
      });
    } else {
      this.loading = false;
    }
  },
};
</script>
